module.exports = __webpack_public_path__ + "static/media/pt-lobby-banner.dd19512c.png";